module.exports = __webpack_public_path__ + "img/logo-small-blue.93e68653.jpg";